import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import { api } from "../lib/api";

const leadsCol = collection(db, "leads");

export const createLead = async (payload) => {
  const ref = await addDoc(leadsCol, {
    projectType: payload.projectType || null,
    platforms: payload.platforms || [],
    features: payload.features || [],
    featuresNote: payload.featuresNote || "",
    timeline: payload.timeline || null,
    budget: payload.budget || null,
    name: payload.name || "",
    email: payload.email || "",
    company: payload.company || "",
    referral: payload.referral || "",
    notes: payload.notes || "",
    source: "questionnaire-wizard-v1",
    status: "new",
    userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
    referrer: typeof document !== "undefined" ? document.referrer || "" : "",
    createdAt: serverTimestamp(),
  });

  // Alert the studio a new brief landed (fire-and-forget — a notification
  // failure must never block the visitor's "Talk soon" confirmation). Public
  // endpoint: the visitor is anonymous, so no auth token is required.
  api
    .post("/lead-notification", {
      name: payload.name || "",
      email: payload.email || "",
      company: payload.company || "",
      projectType: payload.projectType || "",
      budget: payload.budget || "",
      intent: payload.intent || "brief",
    })
    .catch(() => {});

  return ref;
};

export const subscribeAllLeads = (cb) =>
  onSnapshot(query(leadsCol, orderBy("createdAt", "desc")), (snap) =>
    cb(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
  );

export const setLeadStatus = (id, status) =>
  updateDoc(doc(db, "leads", id), { status });

export const deleteLead = (id) => deleteDoc(doc(db, "leads", id));
